// components/NotificationIcon.jsx
import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../context/NotificationContext';

const NotificationIcon = ({ userId }) => {
  const navigate = useNavigate();
  const { unreadCount } = useNotification(); // Get unreadCount from context

  const handleClick = () => {
    navigate('/notifications');
  };

  return (
    <Tooltip title="Notifications">
      <IconButton 
        color="inherit" 
        onClick={handleClick}
        sx={{ 
          position: 'relative',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Badge 
          badgeContent={unreadCount} 
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.7rem',
              height: '20px',
              minWidth: '20px',
            }
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationIcon;